import { useState } from 'react';

export type Language = 'en' | 'no';

const STORAGE_KEY = 'mh_lang';

function readLang(): Language {
  return (localStorage.getItem(STORAGE_KEY) as Language) ?? 'en';
}

export function useLanguage(): [Language, (l: Language) => void] {
  const [lang, setLangState] = useState<Language>(readLang);

  const setLang = (l: Language) => {
    localStorage.setItem(STORAGE_KEY, l);
    setLangState(l);
  };

  return [lang, setLang];
}
